import { render } from "./AllUsers.vue?vue&type=template&id=67e08c6b"
import script from "./AllUsers.vue?vue&type=script&lang=js"
export * from "./AllUsers.vue?vue&type=script&lang=js"

import "./AllUsers.vue?vue&type=style&index=0&id=67e08c6b&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__